
import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import { usePersistentUserLocalStorage as useUserLocalStorage } from '../../../hooks/useUserLocalStorage';

const STORAGE_KEY = 'withOwnership';

const WithOwnershipContext = createContext<any>({
  withOwnershipConfig: { showWithOwnership: false },
  setWithOwnershipConfig: () => {},
});

export const useWithOwnershipContext = () => useContext(WithOwnershipContext);

const initialValue = { showWithOwnership: false };
interface WithOwnershipProviderProps {
  children: ReactNode;
}

export const WithOwnershipProvider = ({ children }: WithOwnershipProviderProps) => {
  const [withOwnershipConfig, setWithOwnershipConfig] = useUserLocalStorage(STORAGE_KEY, initialValue);

  const value = useMemo(() => ({
    withOwnershipConfig: withOwnershipConfig || false,
    setWithOwnershipConfig,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [withOwnershipConfig]);

  return (
    <WithOwnershipContext.Provider value={value}>
      {children}
    </WithOwnershipContext.Provider>
  );
};
